/**
 * Error to throw when something must be aborted with an error.
 */
class AbortError extends Error {
  constructor(message) {
    super(message);
    Object.setPrototypeOf(this, AbortError.prototype);
    this.name = 'AbortError';
  }

}

export { AbortError as A };
